export default __webpack_public_path__ + "static/media/gallery_03.6e2f4a27.jpg";